import { AxiosError, isAxiosError } from 'axios'
import { httpClient } from 'shared/lib'

import consoleMessage from 'shared/utils/helpers/consoleMessage'

import { CustomerAddressesType } from '../types'

export function getCustomerAddressesService(reflinkUuid: string, verificationHeader: string) {
   let errMessage = ''
   return httpClient
      .get<CustomerAddressesType>(`/client-carts/reflinks/${reflinkUuid}/available-addresses`, {
         headers: {
            'X-Reflink-Verification-Code': verificationHeader,
         },
      })
      .then((res) => ({ data: res.data, status: res.status }))
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('CLIENT_CART_REFLINK getCustomerAddresses service', errMessage, 'error')
         throw error
      })
}
